import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'reference', label: 'Référence' },
  { id: 'name', label: 'Nom' },
  { id: 'color', label: 'Couleur' },
  { id: 'size', label: 'Taille' },
  { id: 'barcodeValue', label: 'Code-barres' },
  { id: 'quantity', label: 'Quantité' }
];
/**
 * Entête du tableau comparatif dans la section d'un reception
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left" style={{ fontWeight: 'bold' }}>
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
